<!-- 选课类型 -->
<template>
<div>
    <div class="index" v-if="!detail.show&&!setting.show">
        <div class="title">
            <div class="span1">
                {{$route.name}}
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="">
                    <el-input v-model="queryParams.name" placeholder="请输入类型名称"></el-input>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" align="center">
				    </el-table-column>
                    <el-table-column prop="name" label="类型名称" align="left">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{

    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
			},
			userList:[],
			semesterList: [],
			teacherList:[],
			tableData: [
				// {name:'作业辅导',id:'22131'},
				// {name:'科普',id:'11231'},
                // {name:'文体',id:'2221131131'},
				// {name:'艺术',id:'2213'},
				// {name:'劳动',id:'1131'},
                // {name:'阅读',id:'221131131'},
				// {name:'兴趣小组',id:'22153'},
				// {name:'社团活动',id:'11319'},
                // {name:'其他',id:'22113113'},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
			setting:{
				info:{},
				show:false,
			},
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        del(item){

        },
        toIndex(){
            this.detail.show=false;
			this.setting.show=false;
        },
		edit(item){
			
		},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		.title-right{
			height: 42px;
			padding: 5px;
			display: flex;
		}
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 200px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
